import { Form } from 'react-final-form';
import { Box, Grid } from '@mui/material';

import { TextField, ConfirmDialog, LinearProgress } from '@occc-app/design-system';
import { RetailerNetworkUserFragment } from '@occc/graphql';

import { validateRetailerNetworkUserUpdate } from './retailer-network-user-update-dialog.validation';
import {
  RetailerNetworkUserUpdateFormProps,
  RetailerNetworkUserUpdateFormValues,
} from './retailer-network-user-update-dialog.types';

type RetailerNetworkUserUpdateDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: RetailerNetworkUserUpdateFormValues) => Promise<void>;
  retailerNetworkUser: RetailerNetworkUserFragment;
};

export const RetailerNetworkUserUpdateDialog = ({
  open,
  onClose,
  onSubmit,
  retailerNetworkUser,
}: RetailerNetworkUserUpdateDialogProps) => {
  const user = retailerNetworkUser.openCommerceUser;
  const renderForm: RetailerNetworkUserUpdateFormProps['render'] = ({
    handleSubmit,
    submitting,
    pristine,
    valid,
  }) => (
    <ConfirmDialog
      dialogTitle='Edit User Details'
      onClose={onClose}
      open={open}
      maxWidth='sm'
      fullWidth
      confirmButtonText='Update'
      confirmButtonProps={{
        onClick: handleSubmit,
        disabled: !valid || pristine || submitting,
      }}
    >
      <Box pt={1}>
        {submitting && <LinearProgress sx={{ mb: 3 }} />}
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField required name='firstName' label='First Name' />
          </Grid>
          <Grid item xs={6}>
            <TextField required name='lastName' label='Last Name' />
          </Grid>
          <Grid item xs={6}>
            <TextField name='phoneNumber' label='Mobile Phone Number' />
          </Grid>
          <Grid item xs={6}>
            <TextField required type='email' name='email' label='Email' />
          </Grid>
        </Grid>
      </Box>
    </ConfirmDialog>
  );

  return (
    <Form<RetailerNetworkUserUpdateFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      validate={validateRetailerNetworkUserUpdate}
      keepDirtyOnReinitialize
      initialValues={{
        firstName: user?.name.first || '',
        lastName: user?.name.last || '',
        email: user?.email,
        phoneNumber: user?.phoneNumber,
      }}
    />
  );
};
